import { render, staticRenderFns } from "./AddEditCity.vue?vue&type=template&id=5c932a71&scoped=true"
import script from "./AddEditCity.vue?vue&type=script&lang=js"
export * from "./AddEditCity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c932a71",
  null
  
)

export default component.exports